module.exports = __webpack_public_path__ + "static/media/sortIcon.08aa910c.svg";